<template>
  <v-card flat class="futuristic-card">
    <v-card-title class="card-header">
      <h4 class="earth-color">VOLUME REPORT</h4>
      <div class="title-decoration"></div>
    </v-card-title>
    <v-tabs
      slider-color="#587e27"
      background-color="transparent"
      class="futuristic-tabs"
    >
      <v-tab key="pivot" class="earth-color">Pivot Table</v-tab>
      <!-- Uncomment if needed -->
      <!-- <v-tab key="volumechart">Chart</v-tab> -->
      
      <v-tab-item key="pivot">
        <v-container>
          <div class="pivot-container">
            <pivot
              :data="dailyReportData"
              :fields="fields"
              :row-fields="rowFields"
              :col-fields="colFields"
              :reducer="reducer"
              :default-show-settings="defaultShowSettings"
              class="futuristic-pivot"
            >
              <template slot="loading">
                <div class="loading-container">
                  <v-progress-circular indeterminate color="#587e27"></v-progress-circular>
                  <span class="loading-text">Loading data, please wait...</span>
                </div>
              </template>
              <template slot="value" slot-scope="{ value }">
                {{ value.toLocaleString() }}
              </template>
            </pivot>
          </div>
        </v-container>
      </v-tab-item>
      
      <v-tab-item key="volumechart">
        <v-container>
          <h6 class="earth-color">Volume Distribution</h6>
          <ve-ring
            :data="chartData"
            :settings="chartSettings"
            :loading="loading"
            height="400px"
            class="futuristic-chart"
          ></ve-ring>
        </v-container>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import Pivot from '@marketconnect/vue-pivot-table'
import PivotTable from '@marketconnect/vue-pivot-table'

export default {
  components: { Pivot, PivotTable },
  name: 'Volume',
  data () {
    return {
      chartSettings: {
        radius: [10, 100],
        offsetY: 150,
        label: {
          show: true,
          position: 'center'
        }
      },
      chartData: {
        columns: ['Destination', 'Conservancy_Fee_Category', 'Total_Cost'],
        rows: this.dailyReportData
      },
      loading: true,
      dataEmpty: true,
      data: this.dailyReportData,
      asyncData: [],
      fields: [
        {
          getter: item => item.No_of_Nights,
          label: 'No of Nights'
        },
        {
          getter: item => item.No_of_Guests,
          label: 'No of Guests'
        }
      ],
      rowFields: [
        {
          getter: item => item.Booking_Ref,
          label: 'Booking Ref'
        },
        {
          getter: item => item.Conservancy_Fee_Category,
          label: 'Conservancy Fee'
        },
        {
          getter: item => item.Receipts,
          label: 'Receipts'
        },
        {
          getter: item => item.Client_Name,
          label: 'Client Name'
        }
      ],
      colFields: [
        {
          getter: item => item.Destination,
          label: 'Destination'
        },
        {
          getter: item => item.Currency,
          label: 'Currency'
        }
      ],
      reducer: (sum, item) => sum + item.Total_Cost,
      defaultShowSettings: true,
      isDataLoading: true
    }
  },
  beforeCreate () {
    var data2 = {
      start_date: this.$moment().startOf('month').format('YYYY-MM-DD'),
      end_date: this.$moment().endOf('month').format('YYYY-MM-DD'),
      session_id: localStorage.getItem('lkjhgfdsa')
    }
    this.$store.dispatch('fetch_booking_volume_reports', data2)
    this.$store.dispatch('fetch_daily_reports', data2)
    this.$store.dispatch('fetch_gate_entry_reports', data2)
  },
  created () {
    this.isDataLoading = true
    setTimeout(() => {
      this.asyncData = this.data
      this.isDataLoading = false
      this.loading = false
    }, 3000)
  }
}
</script>

<style scoped>
/* Futuristic Card */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px 8px 0 0;
  display: flex;
  flex-direction: column;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
}

.card-header .earth-color {
  font-size: 1.5rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-top: 8px;
  width: 100px;
}

/* Tabs styling */
.futuristic-tabs {
  margin-top: 8px;
}

.futuristic-tabs >>> .v-tab {
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
}

.futuristic-tabs >>> .v-tab--active {
  color: #587e27 !important;
}

.futuristic-tabs >>> .v-slider {
  color: #587e27;
}

/* Pivot table styling */
.pivot-container {
  border-radius: 8px;
  overflow: hidden;
  margin: 8px 0;
}

.futuristic-pivot >>> table {
  width: 100%;
  border-collapse: collapse;
  font-family: inherit;
}

.futuristic-pivot >>> th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  color: #587e27;
  padding: 12px;
  font-weight: 600;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.futuristic-pivot >>> td {
  padding: 10px 12px;
  border-bottom: 1px solid #e0e0e0;
}

.futuristic-pivot >>> tr:hover {
  background-color: #f5f7fa;
}

.futuristic-pivot >>> .pivot-table-total {
  background-color: #e8f5e9;
  font-weight: 600;
}

/* Chart styling */
.futuristic-chart {
  border-radius: 8px;
  padding: 16px;
  background: #f5f7fa;
  margin-top: 16px;
}

/* Loading styling */
.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  flex-direction: column;
}

.loading-text {
  margin-top: 16px;
  color: #587e27;
  font-weight: 500;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .futuristic-card {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .card-header .earth-color {
    font-size: 1.25rem;
  }

  .futuristic-pivot >>> th,
  .futuristic-pivot >>> td {
    padding: 8px 10px;
    font-size: 0.9rem;
  }
}

@media (max-width: 600px) {
  .futuristic-card {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .card-header .earth-color {
    font-size: 1.1rem;
  }

  .futuristic-pivot >>> th,
  .futuristic-pivot >>> td {
    padding: 6px 8px;
    font-size: 0.85rem;
  }
  
  .futuristic-tabs >>> .v-tab {
    font-size: 0.8rem;
    padding: 0 12px;
  }
}
</style>